<template>
  <div class="bar-chart-container pt-5 pr-5">
    <Bar
      :chart-options="chartOptions"
      :chart-data="chartData"
      :chart-id="chartId"
      :dataset-id-key="datasetIdKey"
      :plugins="[ChartDataLabels]"
      :css-classes="cssClasses"
      :styles="styles"
      :width="width"
      :height="height"
    />
  </div>
</template>

<script>
import { Bar } from "vue-chartjs/legacy";
import ChartDataLabels from "chartjs-plugin-datalabels";
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
} from "chart.js";

ChartJS.register(
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  ChartDataLabels
);

export default {
  name: "BarChart",
  components: { Bar },
  props: {
    chartId: {
      type: String,
      default: "bar-chart",
    },
    datasetIdKey: {
      type: String,
      default: "label",
    },
    width: {
      type: Number,
      default: 400,
    },
    height: {
      type: Number,
      default: 400,
    },
    cssClasses: {
      default: "",
      type: String,
    },
    styles: {
      type: Object,
      default: () => {},
    },
    plugins: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ChartDataLabels,
      chartData: {
        labels: [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
        ],
        datasets: [
          {
            label: "Demo Completed",
            backgroundColor: "#AC9EE4",
            data: [40, 20, 200, 39, 100, 40, 39].map((v) =>
              v === 0 ? null : v
            ),
          },
        ],
      },
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: "bottom" },
          datalabels: {
            anchor: "end",
            align: "top",
            color: "#000",
            // font: { weight: "bold", size: 12 },
            formatter: (value) => (value == null ? "" : value),
          },
        },
        scales: {
          x: {
            grid: { display: false },
          },
          y: {
            beginAtZero: true,
            grid: { display: false },
            ticks: { stepSize: 10 },
          },
        },
      },
    };
  },
  mounted() {
    // 🔹 Dynamically set Y-axis max = highest value + 10
    const dataValues = this.chartData.datasets[0].data.map((v) => v || 0);
    const maxValue = Math.max(...dataValues);
    const suggestedMax = Math.ceil((maxValue + 20) / 10) * 10;

    this.chartOptions.scales.y.max = suggestedMax;
  },
};
</script>

<style scoped>
.bar-chart-container {
  width: 100%;
  height: 100%;
  max-width: 100%;
  margin: auto;
  position: relative;
}
.bar-chart-container canvas {
  height: 280px !important;
}
</style>
